import { useContext, useMemo } from 'react';

import { SidebarStateContext } from 'contexts/sidebarStateContext';
import { ReferenceCandidate } from 'types/suggestions/LoadBuildingSuggestions';

import { getReferenceCandidates } from './utils';

// Candidates of the Builder suggestion the rep is working from; empty for any other suggestion.
export function useReferenceCandidates(): ReferenceCandidate[] {
  const {
    currentState: { clickedSuggestion },
  } = useContext(SidebarStateContext);

  return useMemo(
    () => getReferenceCandidates(clickedSuggestion),
    [clickedSuggestion]
  );
}
